const he = require('he');
module.exports = function(content, sanitize) 
{
    let input = "";
    if(typeof(content) == "object"){
        return content;
    }
    if(typeof(content) == "string"){
        input = content.trim();
    }
    // decode html entities
    input = he.decode(input);
    input = sanitize(input);
    input = input.replace(/&amp;/g, "&");
    return input;
}